import script from "./MyBotView.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBotView.vue?vue&type=script&setup=true&lang=js"

import "./MyBotView.vue?vue&type=style&index=0&id=0f22a19a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f22a19a"]])

export default __exports__